import { useState } from 'react'
import { Brain, MessageSquare, Image, Lightbulb } from 'lucide-react'
import OIRPracticeEnhanced from '../components/PracticeWidgets/OIRPracticeEnhanced'
import WATPractice from '../components/PracticeWidgets/WATPractice'
import TATPractice from '../components/PracticeWidgets/TATPractice'
import SRTPractice from '../components/PracticeWidgets/SRTPractice'

export default function Practice({ state, updateState }) {
  const [activeModule, setActiveModule] = useState(null)

  const modules = [
    {
      id: 'oir',
      title: 'OIR (Officer Intelligence Rating)',
      description: 'Test your reasoning and intelligence with multiple choice questions',
      icon: Brain,
      color: 'bg-blue-500',
      component: OIRPracticeEnhanced,
    },
    {
      id: 'wat',
      title: 'WAT (Word Association Test)',
      description: 'Form meaningful sentences for given words within time limit',
      icon: MessageSquare,
      color: 'bg-green-500',
      component: WATPractice,
    },
    {
      id: 'tat',
      title: 'TAT (Thematic Apperception Test)',
      description: 'Write stories based on ambiguous pictures',
      icon: Image,
      color: 'bg-purple-500',
      component: TATPractice,
    },
    {
      id: 'srt',
      title: 'SRT (Situation Reaction Test)',
      description: 'Respond to challenging situations with your immediate reactions',
      icon: Lightbulb,
      color: 'bg-orange-500',
      component: SRTPractice,
    },
  ]

  if (activeModule) {
    const module = modules.find((m) => m.id === activeModule)
    const Component = module.component

    return (
      <div className="animate-slide-in">
        <button
          onClick={() => setActiveModule(null)}
          className="btn-secondary mb-6"
        >
          ← Back to Modules
        </button>
        <Component state={state} updateState={updateState} />
      </div>
    )
  }

  return (
    <div className="space-y-8 animate-slide-in">
      <div>
        <h1 className="text-3xl font-bold mb-2">Practice Modules</h1>
        <p className="text-gray-600 dark:text-gray-400">
          Select a module to start practicing. You'll get immediate feedback on your answers.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {modules.map((module) => {
          const Icon = module.icon
          return (
            <button
              key={module.id}
              onClick={() => setActiveModule(module.id)}
              className="card text-left hover:scale-105 transform transition-all"
            >
              <div className="flex items-start space-x-4">
                <div className={`${module.color} w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-2">{module.title}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {module.description}
                  </p>
                </div>
              </div>
            </button>
          )
        })}
      </div>

      <div className="card bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500">
        <h3 className="font-bold text-lg mb-2">Practice Mode Benefits</h3>
        <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
          <li>• Get immediate feedback on your answers</li>
          <li>• See ideal solutions and explanations</li>
          <li>• Unlimited attempts to improve</li>
          <li>• Progress saved automatically</li>
          <li>• No time pressure - learn at your own pace</li>
        </ul>
      </div>
    </div>
  )
}
